import {AutoMap} from '@automapper/classes';
import {TBaseModel, TListBaseModel} from './common/t-base.model';
import {
  UserSettingReminderFrequencyTypeEnum,
  userSettingReminderFrequencyTypeEnumToGeneralTypeModel
} from '../enums/user-setting-reminder-frequencytype.enum';
import {FormField} from '../../core/decorators/form-field.decorator';
import {Validators} from '@angular/forms';
import {SourceTypeEnum, sourceTypeEnumToGeneralTypeModel} from '../enums/source-type.enum';
import {TIME_ZONES_CONSTANTS} from '../../core/constants/time-zones.constants';

export class UserSettingListModel extends TListBaseModel {
  @AutoMap()
  reminderIsEnabled!: boolean;

  @AutoMap()
  reminderFrequencyType!: UserSettingReminderFrequencyTypeEnum;

  @AutoMap()
  highlightsCountPerReminder!: number;

  @AutoMap()
  highlightRecency!: number;

  @AutoMap()
  preferredReminderTime!: string;

  @AutoMap()
  timeZone!: string;
}

export class UserSettingModel extends TBaseModel {
  @FormField({
    type: 'toggle',
    previewName: 'reminder is enabled',
    default: '',
    validators: [Validators.required]
  })
  @AutoMap()
  reminderIsEnabled!: boolean;

  @FormField({
    type: 'select',
    previewName: 'reminder frequency type',
    selectTypeValues: Object.values(UserSettingReminderFrequencyTypeEnum).filter((v): v is number => typeof v === 'number') as number[],
    selectTypeEnumGeneralModelFunction: userSettingReminderFrequencyTypeEnumToGeneralTypeModel,
    default: UserSettingReminderFrequencyTypeEnum.EveryDay,
    validators: [Validators.required]
  })
  @AutoMap()
  reminderFrequencyType!: UserSettingReminderFrequencyTypeEnum;

  @FormField({
    type: 'range',
    previewName: 'highlights count per reminder',
    default: 5,
    rangeStep: 1,
    rangeMinValue: 1,
    rangeMaxValue: 100,
    validators: [Validators.required, Validators.min(1), Validators.max(100)]
  })
  @AutoMap()
  highlightsCountPerReminder!: number;

  @FormField({
    type: 'range',
    previewName: 'highlights recency',
    default: 5,
    rangeStep: 1,
    rangeMinValue: 1,
    rangeMaxValue: 10,
    validators: [Validators.required, Validators.min(1), Validators.max(10)]
  })
  @AutoMap()
  highlightRecency!: number;

  @FormField({
    type: 'time',
    previewName: 'preferred reminder time',
    default: '09:00',
    validators: [Validators.required]
  })
  @AutoMap()
  preferredReminderTime!: string;

  @FormField({
    type: 'select',
    previewName: 'time zone',
    selectTypeValues: TIME_ZONES_CONSTANTS,
    selectGetValueFromEnum: false,
    default: Intl.DateTimeFormat().resolvedOptions().timeZone,
    validators: [Validators.required]
  })
  @AutoMap()
  timeZone!: string;
}
